import classnames from 'classnames';

import styles from './FileDragAndDrop.module.scss';

import { FileInput } from '@components/FileInput';
import { translate } from '@chaika/i18n/helper';

import { useFileDragAndDrop, FileDragAndDropProps } from './hooks/useFileDragAndDrop';

export function FileDragAndDrop(props: FileDragAndDropProps) {
    const { areaRef, isActive, loadProgress, onFileAdd } = useFileDragAndDrop(props);

    const { acceptFileTypes, multipleFileLoad } = props;

    const tChooseFiles = translate('chooseFiles');
    const tChooseFilesPartTwo = translate('chooseFilesPartTwo');
    const tLoad = translate('load');

    return (
        <div
            ref={areaRef}
            className={classnames([styles.root, isActive && styles.isActive])}
        >
            {loadProgress === null ? (
                <>
                    <div className={styles.loadButton}>
                        <FileInput
                            multipleFileLoad={multipleFileLoad}
                            acceptFileTypes={acceptFileTypes}
                            onFileAdd={onFileAdd}
                        >
                            {tChooseFiles}
                        </FileInput>
                    </div>
                    <span className={styles.hint}>{tChooseFilesPartTwo}</span>
                </>
            ) : (
                <>
                    <div className={styles.loadProgress}>
                        <div
                            className={styles.loadProgressBar}
                            style={{ width: `${loadProgress}%` }}
                        />
                    </div>
                    <div>
                        {tLoad} {loadProgress}%
                    </div>
                </>
            )}
        </div>
    );
}
